import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@cwos/ui-shared';
import { Pill } from './Pill';
export function Origin({ source, connectorName = null, vendorAbsentSince = null, lastSyncedAt = null, }) {
    if (source !== 'imported')
        return null;
    const freshness = lastSyncedAt ? ` ${t('provenance.lastSynced', { t: lastSyncedAt })}` : '';
    if (vendorAbsentSince) {
        return (_jsxs("span", { children: [_jsx(Pill, { variant: "look", dot: true, children: t('provenance.vendorAbsentPill') }), ' ', _jsxs("span", { role: "note", children: [t('provenance.vendorAbsent'), freshness] })] }));
    }
    return (_jsxs("span", { children: [connectorName
                ? t('provenance.bookedIn', { name: connectorName })
                : t('provenance.bookedInEhr'), freshness] }));
}
//# sourceMappingURL=Origin.js.map